import React from 'react';
import {
    Grid,
    Paper,
    Table,
    TableBody,
    Typography
} from 'material-ui';
import TagTranslationsTableHeader from './TagTranslationsTableHeader';
import TagTranslationsTableItem from './TagTranslationsTableItem';
import TagTranslationDeleteDialog from './TagTranslationDeleteDialog';
import {getFilteredDataBySiteId} from '../../../components/helpers/helpers';
import {BackButton} from '../../../components/buttons/BackButton';

class TagTranslationsTable extends React.Component {

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.sites.length > 0;
    }

    render() {

        const {
            classes,
            tag,
            sites,
            tagTranslations,
            handleClick,
            handleClickOpen,
            open,
            handleSubmit,
            handleRequestClose,
            createTagTranslation,
            updateTagTranslation,
            editTextFieldInline,
            addTextFieldInline,
            getTranslationForSite,
            tagTranslationBySite,
            newTranslated
        } = this.props;

        return (
            <Grid container>
                <div className="heading">
                    <p className="lead">Translations for Tag: <em>"{tag.display_name}"</em></p>
                </div>
                <Paper className={classes.rootTagsTable}>
                    <Table className={classes.table}>
                        <TagTranslationsTableHeader
                            classes={classes}
                        />
                        <TableBody>
                            {sites.map((site, index) =>
                                <TagTranslationsTableItem
                                    key={site.id}
                                    tag={tag}
                                    site={site}
                                    newTranslated={newTranslated}
                                    tagTranslation={getFilteredDataBySiteId(tagTranslations, site.id)}
                                    tagTranslationBySite={tagTranslationBySite}
                                    classes={classes}
                                    handleClick={handleClick}
                                    handleClickOpen={handleClickOpen}
                                    createTagTranslation={createTagTranslation}
                                    updateTagTranslation={updateTagTranslation}
                                    editTextFieldInline={editTextFieldInline}
                                    addTextFieldInline={addTextFieldInline}
                                    getTranslationForSite={getTranslationForSite}
                                />
                            )}
                        </TableBody>
                        <TagTranslationDeleteDialog
                            tag={tag}
                            classes={classes}
                            open={open}
                            handleSubmit={handleSubmit}
                            handleRequestClose={handleRequestClose}
                        />
                    </Table>
                </Paper>
                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        <Typography variant="body2" color="error">* To add/edit a translation for a tag name please click on each row in the table under the <strong>Tag Translated Name</strong> column.</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2" color="error">* Please only make changes and save for <em>one tag at a time</em>!</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2" color="error">* Once you have made the changes click the Save button corresponding for each row.</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2" color="error">* If you wish to cancel the changes, click the Discard button corresponding for each row.</Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        <BackButton
                            link={"/tags"}
                            variant="raised"
                            className="floatRight"
                        />
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default TagTranslationsTable;



// WEBPACK FOOTER //
// ./src/containers/tags/translations/TagTranslationsTable.jsx